import * as React from 'react';
import { ReactElement, useEffect, useState } from 'react';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import { getBackOrderHistories } from 'api/backorder';
import { BackOrderHistory, BackOrderHistoryResponse } from 'types/api/backorder';
import PlanTable from 'components/backorder/table/planTable/PlanTable';
import {
  backOrderHistoryTableColumns,
  backOrderHistoryTableHeader,
} from 'components/backorder/table/planTable/planTableData';

interface Props {
  groupId: string;
}
const BackOrderList = ({ groupId }: Props): ReactElement => {
  const [backOrderHistory, setBackOrderHistory] = useState<BackOrderHistoryResponse | null>(null);
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(1);

  const getBackOrderHistoryData = async (pageNo = 1): Promise<void> => {
    const res = await getBackOrderHistories({ groupId, pageNo });
    if (!res) return;
    setBackOrderHistory(res);
  };

  const onChangePage = async (pageNo: number): Promise<void> => {
    setCurrentPageIndex(pageNo);
    await getBackOrderHistoryData(pageNo);
  };

  useEffect(() => {
    getBackOrderHistoryData().then();
  }, []);

  return (
    <DataTableLayout
      showPagination
      tableTitle="Back Order List"
      totalPages={backOrderHistory?.totalPages ?? 0}
      onChangePage={onChangePage}
      currentPageIndex={currentPageIndex}
    >
      <PlanTable<BackOrderHistory>
        planInformation={backOrderHistory?.items ?? []}
        header={backOrderHistoryTableHeader}
        columns={backOrderHistoryTableColumns}
      />
    </DataTableLayout>
  );
};

export default BackOrderList;
